/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * ValidateVat Input Action
 */
export class ValidateVatInput implements Msdyn365.IActionInput {
    public vatId: string;
    public companyName: string;
    constructor(vatId: string, companyName: string) {
        this.vatId = vatId;
        this.companyName = companyName;
    }
    public getCacheKey = () => `DEFAULT ${this.vatId} ${new Date()}`;
    public getCacheObjectType = () => 'IValidateVatData';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IValidateVatData {
    response: IVatResult;
}

export interface IVatResult {
    isValid: boolean;
    isVatCheckExcecuted?: boolean;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ValidateVatInput('', '');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: ValidateVatInput, ctx: Msdyn365.IActionContext): Promise<IValidateVatData> {
    let result: IVatResult = { isValid: false };
    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecValidateVat`,
        'post',
        {
            vatRequestModel: {
                VATNumber: input.vatId,
                Company: input.companyName
            }
        },

        { headers: { OUN: ctx.requestContext.apiSettings.oun } }
    ).then(res => {
        result = {
            isValid: (res?.data as any).Valid,
            isVatCheckExcecuted: (res?.data as any).Executed
        };
    });

    return { response: result };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IValidateVatData>>action,
    id: 'TecValidateVat',
    input: createInput
});
